export default __webpack_public_path__ + "static/media/factory__38.0288ee35.jpg";